import React from 'react';
import { IMaskInput } from 'react-imask';
import PropTypes from 'prop-types';

const YearMask = React.forwardRef(function YearMaskCustom(props, ref) {
    const { onChange, ...other } = props;

    const currentYear = new Date().getFullYear();
    const minYear = 1600;
    const maxYear = currentYear + 10;

    const maskOptions = {
        mask: '0000',  // 4 digits
        blocks: {
            '0000': {
                mask: IMask.MaskedRange,
                from: minYear,
                to: maxYear,
            },
        },
    };

    return (
        <IMaskInput
            {...other}
            inputRef={ref}
            onAccept={(value, mask) => onChange({ target: { name: props.name, value } })}
            overwrite
            {...maskOptions}
        />
    );
});

YearMask.propTypes = {
    inputRef: PropTypes.func,
    onChange: PropTypes.func,
    name: PropTypes.string.isRequired,
};

export default YearMask;
